import React, { useMemo, useState } from "react";
import { AccordionSet, Accordion, Button, RadioButton, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekAutoSuggest, RecekTextField } from "./inputs";
import { useTitleNameSuggestions } from "../hooks/useTitleNameSuggestions";
import { usePublishersData } from "../hooks/usePublishersData";
import { ProvisionalFilterAccordion } from "./filters/ProvisionalFilterAccordion";
import { supportsIssnFilter } from "../utils/titleVerificationFilters";
export var TitleVerificationFilters = function (_a) {
    var filters = _a.filters, titleType = _a.titleType, onFilterChange = _a.onFilterChange, onProvisionalChange = _a.onProvisionalChange, onApplyFilters = _a.onApplyFilters, hasUnappliedChanges = _a.hasUnappliedChanges;
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    var _b = useTitleNameSuggestions({
        scope: "VERIFICATION",
        type: titleType,
    }), suggestions = _b.suggestions, updateSuggestQuery = _b.updateSuggestQuery;
    var _c = useState(""), publisherSuggestQuery = _c[0], setPublisherSuggestQuery = _c[1];
    var publishers = usePublishersData(publisherSuggestQuery, "", "PENDING_VERIFICATION").publishers;
    var publisherSuggestions = useMemo(function () { return publishers.map(function (publisher) { var _a; return (_a = publisher.name) !== null && _a !== void 0 ? _a : ""; }).filter(Boolean); }, [publishers]);
    return (React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.name",
                }), separator: false },
                React.createElement(RecekAutoSuggest, { labelId: "ui-br-legaldeposits.filter.name", showLabel: false, value: filters.name, onChange: function (value) {
                        onFilterChange("name", value);
                        updateSuggestQuery(value);
                    }, suggestions: suggestions, placeholder: formatMessage({
                        id: "ui-br-legaldeposits.filter.name.placeholder",
                    }) })),
            supportsIssnFilter(titleType) && (React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.issn",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-legaldeposits.filter.issn", showLabel: false, value: filters.issn, onChange: function (e) { return onFilterChange("issn", e.target.value); }, placeholder: formatMessage({
                        id: "ui-br-legaldeposits.filter.issn.placeholder",
                    }) }))),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.publisher",
                }), separator: false },
                React.createElement(RecekAutoSuggest, { labelId: "ui-br-legaldeposits.filter.publisher", showLabel: false, value: filters.publisher, onChange: function (value) {
                        onFilterChange("publisher", value);
                        setPublisherSuggestQuery(value);
                    }, suggestions: publisherSuggestions, placeholder: formatMessage({
                        id: "ui-br-legaldeposits.filter.publisher.placeholder",
                    }) })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.investigationStatus",
                }), separator: false },
                React.createElement(RadioButton, { label: formatMessage({
                        id: "ui-br-legaldeposits.filter.investigationStatus.all",
                    }), checked: filters.investigationStatus === "", onChange: function () { return onFilterChange("investigationStatus", ""); } }),
                React.createElement(RadioButton, { label: formatMessage({
                        id: "ui-br-legaldeposits.filter.investigationStatus.none",
                    }), checked: filters.investigationStatus === "NONE", onChange: function () { return onFilterChange("investigationStatus", "NONE"); } }),
                React.createElement(RadioButton, { label: formatMessage({
                        id: "ui-br-legaldeposits.filter.investigationStatus.inProgress",
                    }), checked: filters.investigationStatus === "IN_PROGRESS", onChange: function () {
                        return onFilterChange("investigationStatus", "IN_PROGRESS");
                    } })),
            onProvisionalChange && (React.createElement(ProvisionalFilterAccordion, { titleType: titleType === "PERIODICAL" ? "PERIODICAL" : "MONOGRAPH", checked: filters.provisional, onChange: onProvisionalChange }))),
        React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, type: "submit", disabled: !hasUnappliedChanges },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.apply" }))));
};
